
import { Injectable } from '@angular/core';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  private cache: Map<string, any> = new Map();

  constructor(private logger: LoggerService,) { }

  put(url: string, response: any) {
    this.logger.log('cache miss');
    this.cache.set(url, response);
  }

  get(url: string): any {
    this.logger.log('cache hit');
    return this.cache.get(url);
  }

  clear() {
    this.cache.clear();
  }
}
